import React from 'react'
import { Provider } from 'react-redux'

import configStore from './store'
import Main from './pages/Main'

import './App.css'

const store = configStore()

export default function App() {
  return (
    <Provider store={store}>
      <Main />
    </Provider>
  )

  // 只存在redux 的配置
  // return <PageA />

  // no redux and no react-router
  // return <div>Hello Baicizhan</div>
}
